import {actionCreator} from "../utils";


export const loginFromGoogle = "LOGIN_FROM_GOOGLE"
export const setCurrentUser = "SET_CURRENT_USER"
export default actionCreator({
    loginFromGoogle,
    setCurrentUser
})
